package com.essntl.features.proposal.ui.allproposal.components

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.uikit.components.dropdown.EsDropDownMenu
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing

@Composable
fun ProposalStatusDropDown(
    status: ProposalModel.Status,
    onStatusSelected: (ProposalModel.Status) -> Unit,
    enabled: Boolean = true,
    modifier: Modifier = Modifier,
    style: ProposalStatusStyle = ProposalStatusStyle.Default,
) {
    var isExpanded by remember {
        mutableStateOf(false)
    }

    Box {
        ProposalStatus(
            status = status,
            style = style,
            suffixIconRes = if (enabled) EsIcons.ArrowDown else null,
            modifier = modifier
                .clip(CircleShape)
                .pointerHoverIcon(PointerIcon.Hand)
                .focusProperties { canFocus = false }
                .clickable {
                    if (enabled)
                        isExpanded = true
                },
        )

        EsDropDownMenu(
            expanded = isExpanded,
            onDismissRequest = { isExpanded = false },
            paddingValues = PaddingValues(1.spacing),
            verticalArrangement = Arrangement.spacedBy(1.5f.spacing),
        ) {
            ProposalModel.Status.entries.forEach { status ->
                ProposalStatus(
                    status = status,
                    style = style,
                    modifier = Modifier
                        .clip(CircleShape)
                        .pointerHoverIcon(PointerIcon.Hand)
                        .clickable {
                            onStatusSelected(status)
                            isExpanded = false
                        },
                )
            }
        }
    }
}